<template>
  <div class="home">
    <h1>Welcome</h1>
  </div>
</template>

<script setup lang="ts">
import { setTitle } from '../services/title.service';
setTitle('Home');
</script>
